import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'uw-page-size-options',
    templateUrl: './page-size-options.component.html',
    styleUrls: ['./page-size-options.component.scss'],
    imports: [TranslateModule]
})
export class PageSizeOptionsComponent {

  @Input() pageSizeOptions: number[] = [];

  @Output() readonly pageSizeOptionClick: EventEmitter<number> = new EventEmitter();

  public onKeydown(event: any, pageSizeOption: number): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.pageSizeOptionClick.emit(pageSizeOption);
    }
  }
}

@NgModule({
    exports: [
        PageSizeOptionsComponent
    ],
    imports: [
        CommonModule,
        TranslateModule,
        PageSizeOptionsComponent
    ]
})
export class PageSizeOptionsModule { }
